const config = {
    build_number: '602674',
    build_timestamp: '2025-06-26T15:53:22.436Z',
    build_commit: '7bbadbb0ac6febcee59e6547d5d3c12a2173509b',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
